import axios from "axios";

export interface DeleteEventParams {
  accessToken: string;
  eventId: string;
}

/**
 * Deletes a calendar event from the user's calendar.
 *
 * @param params - Parameters for deleting the event
 */
export async function deleteEvent(params: DeleteEventParams): Promise<void> {
  const { accessToken, eventId } = params;

  if (!accessToken) {
    throw new Error(
      "Access token is missing. Please ensure user is logged in."
    );
  }

  const headers = {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/json",
  };

  try {
    // Delete the event from the user's default calendar
    const deleteUrl = `https://graph.microsoft.com/v1.0/me/events/${eventId}`;
    await axios.delete(deleteUrl, { headers });
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error(
        "Error deleting calendar event:",
        error.response?.data || error.message
      );
      throw new Error(
        `Graph API error: ${error.response?.status} ${
          error.response?.statusText || ""
        }`
      );
    } else {
      console.error("Unknown error:", error);
      throw error;
    }
  }
}
